import { Row } from "@amzn/stencil-react-components/layout";
import { StarRatingDisplay, StarRatingDisplaySize } from "@amzn/stencil-react-components/star-rating";
import { Text } from "@amzn/stencil-react-components/text";
import { TooltipAlignment, withTooltip } from "@amzn/stencil-react-components/tooltip";
import React from "react";
import { FunctionComponent } from "react";

export enum StarAverageRatingSize {
  ExtraSmall,
  Small,
  Medium,
}

export interface StarAverageRatingProps {
  size: StarAverageRatingSize;
  averageRating: number;
  voteNumber?: number;
  tooltipContent?: JSX.Element;
}

const getSizes = (size: StarAverageRatingSize) => {
  switch (size) {
    case StarAverageRatingSize.ExtraSmall:
      return { starRating: StarRatingDisplaySize.ExtraSmall, fontSize: "T100" };
    case StarAverageRatingSize.Small:
      return { starRating: StarRatingDisplaySize.Small, fontSize: "T200" };
    case StarAverageRatingSize.Medium:
      return { starRating: StarRatingDisplaySize.Medium, fontSize: "T300" };
    default:
      return { starRating: StarRatingDisplaySize.Small, fontSize: "T200" };
  }
};

export const StarAverageRating: FunctionComponent<StarAverageRatingProps> = ({
  size,
  averageRating,
  voteNumber,
  tooltipContent,
}) => {
  const sizes = getSizes(size);

  const AverageRatingComponent = () => (
    <StarRatingDisplay value={averageRating} size={sizes.starRating} dataTestId="star-rating-display" />
  );
  const component: JSX.Element = (
    <Row alignItems="center" columnGap={"8px"} dataTestId="star-average-rating">
      <Text fontSize={sizes.fontSize} margin={"4px"} dataTestId="star-average-rating-average">
        {averageRating}
      </Text>
      <AverageRatingComponent />
      {voteNumber !== undefined && (
        <Text fontSize={sizes.fontSize} margin={"4px"} dataTestId="star-average-rating-vote-number">
          ({voteNumber})
        </Text>
      )}
    </Row>
  );

  if (tooltipContent) {
    //should show a tooltip with custom content

    const ComponentWithTooltip = withTooltip()(() => component);
    return (
      <ComponentWithTooltip
        tooltipText={tooltipContent}
        tooltipAlignment={TooltipAlignment.Left}
        tooltipDataTestId="star-average-rating-tooltip"
      />
    );
  }

  return component;
};
